/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LoadingBar/Content",
  backgroundColorBackground = "rgba(0, 188, 112, 0.2)",
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  marginTop = 0,
  height,
  width,
  backgroundColorForeground
  
}) {
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let backgroundColorForegroundOrdtColorsBrandBase = backgroundColorForeground ?? dtColorsBrandBase
let backgroundColorForegroundOrdtColorsBrandBase1 = backgroundColorForeground ?? dtColorsBrandBase
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': backgroundColorBackground,'--bblr-2-Z1Yf8zk': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z1Yf8zk': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-Z1Yf8zk': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-Z1Yf8zk': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-6-Z1Yf8zk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--h-7-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height,'--w-8-Z1Yf8zk': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': backgroundColorForegroundOrdtColorsBrandBase,'--bblr-2-Z1Yf8zk': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z1Yf8zk': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-Z1Yf8zk': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-Z1Yf8zk': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Horizontal1}`}
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': backgroundColorForegroundOrdtColorsBrandBase1,'--bblr-2-Z1Yf8zk': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z1Yf8zk': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-Z1Yf8zk': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-Z1Yf8zk': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Horizontal2}`}
/>
</div>
{children}
</React.Fragment>)
}